import http from '../common/compornents/httpcommon';

class SeihinServ {
  getSeihinData = (params: any) => {
    return http.get('getSeihinData/', { params });
  };
}
export default new SeihinServ();
